<template>
  <div class="accordion mt-2 mb-5" id="accordionNodos">
    <div v-for="(section, index) in sections" :key="index" class="card">
      <div class="card-header" :id="'headingN' + index">
        <h2 class="mb-0">
          <button
            class="btn btn-link btn-block text-left"
            type="button"
            data-toggle="collapse"
            :data-target="'#collapseN' + index"
            aria-expanded="true"
            :aria-controls="'collapseN' + index"
            style="display: flex; justify-content: space-between;"
          >
            <span class="titulo"><p class="m-0">{{ section.titulo }} <span v-if="section.pie_titulo" class="pie-titulo">{{section.pie_titulo}}</span></p></span>
            <span class="descargar"><i class="bx bx-chevron-down icono-down"></i></span>
          </button>
        </h2>
        <div
          :id="'collapseN' + index"
          class="collapse"
          :aria-labelledby="'headingN' + index"
          data-parent="#accordionNodos"
        >
          <div class="card-body">
              <ul v-for="(contenido, i) in section.contenido" :key="i">
                <li>
                  <div class="contenido-fila">
                    <!-- Mostrar título -->
                    <span class="contenido-titulo-sin-archivo" v-if="contenido.url_pdf=='' && contenido.url_word=='' &&  contenido.url_excel=='' && contenido.url_comprimido=='' && contenido.link=='' ">{{ contenido.titulo }}</span>
                    <span v-else class="contenido-titulo">
                      <a v-if="contenido.url_pdf" :href="urlServe + contenido.url_pdf" target="_blank">
                        {{ contenido.titulo }}
                      </a>
                      <a v-if="contenido.url_excel" :href="urlServe + contenido.url_excel" target="_blank">
                        {{ contenido.titulo }}
                      </a>
                      <a v-if="contenido.link" :href="contenido.link" target="_blank">
                        {{ contenido.titulo }}
                      </a>
                    </span>
                  </div>
                  <!-- archivos hijos -->
                  <div v-for="(archivo, ar) in contenido.archivos_seccion" :key="ar" class="mt-2">
                    <div class="contenedor_archivos">
                      <span class="contenido-titulo-sin-archivo" v-if="archivo.url_pdf=='' && archivo.url_word=='' &&  archivo.url_excel=='' && archivo.url_comprimido==''">{{ archivo.titulo }}</span>
                      <span v-else class="contenido-titulo-archivo">
                        <a v-if="archivo.url_pdf" :href="urlServe + archivo.url_pdf" target="_blank">
                          {{ archivo.titulo }}
                        </a>
                        <a v-if="archivo.url_excel" :href="urlServe + archivo.url_excel" target="_blank">
                          {{ archivo.titulo }}
                        </a>
                      </span>
                    </div>
                    <div v-if="archivo.hasOwnProperty('archivos')" >
                      <div v-for="(archivo_nieto, at) in archivo.archivos" :key="at" class="contenedor_archivos_nietos">
                        <!-- {{ archivo_nieto }} -->
                        <span class="contenido-titulo-archivo">
                        <a v-if="archivo_nieto.url_pdf" :href="urlServe + archivo_nieto.url_pdf" target="_blank">
                          {{ archivo_nieto.titulo }}
                        </a>
                        <a v-if="archivo_nieto.url_excel" :href="urlServe + archivo_nieto.url_excel" target="_blank">
                          {{ archivo_nieto.titulo }}
                        </a>
                      </span>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sections: {
      type: Array,
      required: true,
      // Estructura: [{ title: 'Title', items: [{ name: 'Item Name', path: 'item-path', pdf: 'pdf-path', word: 'word-path', excel: 'excel-path', rar: 'rar-path' }, ...] }, ...]
    },
    urlServe: {
      type: String,
      default: ''
    },
    collapse:{
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped>
.accordion .card .card-header {
    border-radius: 0!important;
    margin-bottom: -1px!important;
    background-color: #fff!important;
}
.card-header:first-child {
    border-radius: calc(.25rem - 1px) calc(.25rem - 1px) 0 0!important;
}
.card-header {
    padding: .75rem 1.25rem!important;
    margin-bottom: 0!important;
    background-color: rgba(0, 0, 0, .03)!important;
    border-bottom: 1px solid rgba(0, 0, 0, .125)!important;
}
.card-header .titulo{
    color:#621132;
    transition: ease all .1s;
    font-weight: 400;
}
.item-name .pie-titulo,
.titulo .pie-titulo{
  font-size: .8rem;
  font-style: italic;
  color:#a1a1a1;
  margin-left: 10px;
}
.icons {
    display: flex;
    gap: 10px;
    font-size: 1.5rem;
}
.children .icons {
    display: flex;
    gap: 10px;
    font-size: 1rem;
}
.icons a {
    font-size: 1rem;
    color: #000;
    transition: color 0.2s;
}
.icons a:hover {
    color: #007bff; 
}
.icon-pdf{
    color: #e74c3c!important; 
}
ul{
  margin-bottom: .5rem;
}
ul li {
  list-style-type: none;
  list-style: none;
  /* margin-bottom: 1rem; */
  /* border-bottom: 1px solid #cfcfcf; */
  padding: 0.2rem 0;
  font-size: 14px;
  transition: ease all .1s;
}

.contenido-fila {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.contenido-fila:hover {
    transform: scale(1.01);

}
.contenido-fila .contenido-titulo{
  border-bottom: 1px solid #cfcfcf;
}
.contenido-titulo {
  flex: 1;
  margin-right: 10px;
  font-size: 1rem;
}
.contenido-fila .contenido-titulo-sin-archivo{
  width: 100;
  font-size: 1rem;
  color: #621132;
  font-weight: 600;
}
.contenido-fila a{
  width: 100;
  font-size: 1rem;
  color: #000;
}
/* sección de archivos de hijos  */
.contenedor_archivos{
  display: flex;
  justify-content: space-between;
  margin-left: 3rem;
  margin-right: 1rem;
  border-bottom: 1px dotted #cfcfcf;
}
.contenedor_archivos:hover{
  transform: scale(1.01);
}
.contenedor_archivos .contenido-titulo-archivo a{
  font-size: 0.85rem;
  color: #000;
}

.contenedor_archivos .contenido-titulo-sin-archivo{
  width: 100;
  font-size: 1rem;
  font-weight: 600;
}

.contenedor_archivos .icono-archivo {
  font-size: 1.2rem;
}
a:hover{text-decoration: none;}

/* sección de archivos de hijos  */
.contenedor_archivos_nietos{
  display: flex;
  justify-content: space-between;
  margin-left: 4rem;
  margin-right: 1rem;
  border-bottom: 1px dotted #cfcfcf;
}
.contenedor_archivos_nietos:hover{
  transform: scale(1.01);
}
.contenedor_archivos_nietos .contenido-titulo-archivo a{
  font-size: 0.85rem;
  color: #000;
}
</style>
